import { useMutation, useQueryClient } from '@tanstack/react-query';
import { extendPotSubmitDeadline } from '../api/potsApi';
import { potKeys } from './potKeys';
import { potPeriodKeys } from './potPeriodKeys';

interface ExtendPotSubmitDeadlineParams {
  potId: string;
}

/**
 * Mutation hook for extending a pot's submit deadline by the organisation's
 * configured extension length. The pot keeps its current period — it does
 * not roll over to the current week.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useExtendPotSubmitDeadline() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ potId }: ExtendPotSubmitDeadlineParams) => {
      return await extendPotSubmitDeadline({ potId });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: potKeys.all });
      queryClient.invalidateQueries({ queryKey: potPeriodKeys.all });
    },
  });
}
